module.exports = __webpack_public_path__ + "assets/9bfdff4d2643591333484fb06f6bd7b4.png";